module.exports = __webpack_public_path__ + "static/rocket-586013716bfa7f5737518b034ffb7648.png";